import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, AppDispatch } from '../store';
import {HttpResponse} from "../../services/http.service";
import axios from "axios";
import {PaginationModel} from "../../models/pagination.model";
import {toggleLoader} from "../global/global-slice";
import {CountryModel} from "../../models/country.model";

const initialState: countriesSliceState = {
	countriesLoaded: false,
	countries: []
};

const countriesSlice = createSlice({
	name: 'countries',
	initialState,
	reducers: {
		setCountries(state, action: PayloadAction<CountryModel[]>) {
			state.countriesLoaded = true;
			state.countries = action.payload;
		}
	}
});

export const loadCountries = (): AppThunk => async (dispatch: AppDispatch) => {
	const res: HttpResponse<CountryModel[]> = await axios.get('country/');
	
	if (res.data) {
		dispatch(countriesSlice.actions.setCountries(res.data || []));
	}
}

export default countriesSlice.reducer;

export interface countriesSliceState {
	countriesLoaded: boolean;
	countries: CountryModel[];
}
